module.exports = __webpack_public_path__ + "img/sales.6ec88e02.svg";